<template>
    <modal name="download-link"
           :min-width="200"
           :min-height="200"
           :adaptive="true"
           @before-open="beforeOpen" @click.native="hide">

        <div class="md-content">
            <a id="mp3" :href="'/storage/podcasts/channels/' + track.channel_id + '/'  + track.name"
               :download="track.artist + ' - ' + track.title" style="display: none"></a>
            <a  id="aiff" :href="track.download_link"  style="display: none">1440</a>
            <button class="download-btn first" @click="download('mp3')">MP3 320 kB/s</button>
            <button class="download-btn second" @click="download('aiff')">AIFF 1440 kB/s</button>
        </div>

    </modal>
</template>

<script>

  import SvgIcon from '../layout/SvgIcon'

  export default {
    components: {
      SvgIcon
    },

    data () {
      return {
        track: Object,
      }
    },

    methods: {
      beforeOpen (event) {
        this.track = event.params.track
      },

      hide () {
        this.$modal.hide('download-link')
      },

      download (id) {
        document.getElementById(id).click();
      }
    }
  }
</script>
<style>
    .v--modal-overlay {
        background: rgba(0, 0, 0, 0.8);
    }
    .v--modal{
        background: transparent;
        box-shadow: none;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/modals/DownloadModal.vue